import { faFileContract } from '@fortawesome/pro-regular-svg-icons'
import { Flex, TextInput } from '@mantine/core'
import { useMemo } from 'react'

import { useTranslation } from '@flecto/translations'
import { CollapsibleCard, RichTextEditor } from '@flecto/ui'

import { CheckboxWithDescription } from './CheckboxWithDescription'
import { useFormProfileBookingsContext } from './FormProfileBookings'

export function SectionContracts({
  termsAndConditionsEmpty,
}: {
  termsAndConditionsEmpty: boolean
}) {
  const { t, i18n } = useTranslation('saas', { keyPrefix: 'profile_bookings' })

  const form = useFormProfileBookingsContext()

  const checkboxItems = useMemo(
    () => [
      {
        label: t('label_include_id_on_title'),
        description: t('label_include_id_on_title_description'),
        value: form.values.documents_contract_include_id_on_title,
        field: 'documents_contract_include_id_on_title',
      },
      {
        label: t('label_generated_date'),
        description: t('label_generated_date_description'),
        value: form.values.documents_contract_include_generated_date,
        field: 'documents_contract_include_generated_date',
      },
      {
        label: t('label_customer_details'),
        description: t('label_customer_details_description'),
        value: form.values.documents_contract_include_customer_details,
        field: 'documents_contract_include_customer_details',
      },
      {
        label: t('label_rental_details'),
        description: t('label_rental_details_description'),
        value: form.values.documents_contract_include_rental_details,
        field: 'documents_contract_include_rental_details',
      },
      {
        label: t('label_signature'),
        description: t('label_signature_description'),
        value: form.values.documents_contract_include_signatures,
        field: 'documents_contract_include_signatures',
      },
      {
        label: t('label_qr_code'),
        description: t('label_qr_code_description'),
        value: form.values.documents_contract_include_links,
        field: 'documents_contract_include_links',
      },
      {
        label: t('label_include_terms'),
        description: t('label_include_terms_description'),
        value: form.values.documents_contract_include_terms_and_conditions,
        field: 'documents_contract_include_terms_and_conditions',
      },
    ],
    [form.values, t]
  )

  return (
    <CollapsibleCard opened my='lg'>
      <CollapsibleCard.Title>{t('documents_contracts')}</CollapsibleCard.Title>
      <CollapsibleCard.Description>
        {t('documents_contracts_description')}
      </CollapsibleCard.Description>
      <CollapsibleCard.Icon withCircleBackground icon={faFileContract} />
      <CollapsibleCard.Content>
        <Flex direction='column' gap='lg'>
          <TextInput
            label={t('label_contract_title')}
            maw='345px'
            value={form.values.contract_title}
            onChange={(e) =>
              form.setFieldValue('contract_title', e.target.value)
            }
            placeholder={t('label_contract_title_placeholder')}
          />

          <Flex direction='column'>
            <RichTextEditor
              key={`rich-text-editor-contract-body-${i18n.language}`}
              label={t('label_contract_body')}
              placeholder={t('label_contract_body_placeholder')}
              onChange={(value) =>
                form.setFieldValue('contract_body', String(value))
              }
              value={form.values.contract_body}
            />
          </Flex>

          {checkboxItems.map((item, index) => (
            <CheckboxWithDescription
              key={index}
              label={item.label}
              description={item.description}
              value={item.value}
              onChange={(value: boolean) =>
                form.setFieldValue(item.field, value)
              }
              disabled={
                item.field ===
                  'documents_contract_include_terms_and_conditions' &&
                termsAndConditionsEmpty
              }
            />
          ))}
        </Flex>
      </CollapsibleCard.Content>
    </CollapsibleCard>
  )
}
